import LoginSubheading from './LoginSubheading';
export default LoginSubheading;